export default __webpack_public_path__ + "static/media/sign_in_background.ac78adcb.png";